import { useDispatch, useSelector } from 'react-redux';
import { useDigitalMarketingSlice } from '../slice';
import { selectDigitalMarketing } from '../slice/selectors';
import { useCallback } from 'react';

export const useBlogActions = () => {
  const { actions } = useDigitalMarketingSlice();
  const dispatch = useDispatch();
  const digitalMarketingState = useSelector(selectDigitalMarketing);

  const fetchBlogs = useCallback(
    (
      institute_id: number,
      branch_id: number,
      publish_filter?: string,
      page?: number,
      page_size?: number,
      search?: string
    ) => {
      dispatch(
        actions.fetchBlogsStart({
          institute_id,
          branch_id,
          publish_filter,
          page,
          page_size,
          search,
        })
      );
    },
    [dispatch, actions]
  );

  const fetchBlogById = useCallback(
    (id: number) => {
      dispatch(actions.fetchBlogByIdStart({ id }));
    },
    [dispatch, actions]
  );

  const upsertBlog = useCallback(
    (payload: any) => {
      dispatch(actions.upsertBlogStart(payload));
    },
    [dispatch, actions]
  );

  const publishBlog = useCallback(
    (blog_id: number, is_published: boolean) => {
      dispatch(actions.publishBlogStart({ blog_id, is_published }));
    },
    [dispatch, actions]
  );

  const deleteBlog = useCallback(
    (id: number) => {
      dispatch(actions.deleteBlogStart({ id }));
    },
    [dispatch, actions]
  );

  const clearState = useCallback(() => {
    dispatch(actions.clearState());
  }, [dispatch, actions]);

  return {
    ...digitalMarketingState,
    fetchBlogs,
    fetchBlogById,
    upsertBlog,
    publishBlog,
    deleteBlog,
    clearState,
  };
};
